<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7387wq/tc-custom/9781467422376.jpg?1730408932629" alt="This image is the cover for the book The Gospel and Letters of John, Volume 2, The Eerdmans Critical Commentary (ECC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gospel and Letters of John, Volume 2, The Eerdmans Critical Commentary (ECC)
      </h1>
      <p class="bookDescription body article font2">
        <p>Urban von Wahlde’s radically new, three-volume commentary on the Gospel and Letters of John is the most detailed study of the composition of the Johannine literature ever put forth by an American scholar. / Nearly all of the problems confronted by those who study John have to do with the literary strata of the Gospel of John and their relation to the composition of the Letters of John. With an archaeologist’s precision, and engaging a whole range of scholarly contributions in this area, von Wahlde digs down to the foundations and exposes three distinct literary strata in the development of the Johannine tradition. Volume 1 gives detailed evidence identifying and listing the criteria for each stratum. Volumes 2 and 3 apply those criteria to the Gospel and Letters of John respectively. / These books are part of the Eerdmans Critical Commentary series, edited by David Noel Freedman and Astrid B. Beck.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Urban C. von Wahlde
      </h2>
      
      <p class="authorDescription body article">Urban C. von Wahlde is professor of New Testament at LoyolaUniversity Chicago. He is also the author of TheJohannine Commandments: 1 John and the Struggle for theJohannine Tradition and The Earliest Version ofJohn's Gospel: Recovering the Gospel of Signs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1523df0d